// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__G1l9r","buttons":"PendingPaymentAlert_buttons__2P2dh"};